import * as React from "react";
import { cn } from "~/lib/utils";

type SkeletonAnimation = "none" | "pulse" | "shimmer";

interface SkeletonProps extends React.ComponentProps<"div"> {
  animation?: SkeletonAnimation;
  animationDurationMs?: number;
}

function Skeleton({
  animation = "pulse",
  animationDurationMs = 2400,
  className,
  style,
  ...props
}: SkeletonProps) {
  const animationStyle =
    animation === "shimmer"
      ? ({
          "--skeleton-shimmer-duration": `${animationDurationMs}ms`,
          animationDuration: `${animationDurationMs}ms`,
        } as React.CSSProperties)
      : undefined;

  return (
    <div
      data-slot="skeleton"
      className={cn(
        "rounded-2xl bg-muted",
        animation === "pulse" ? "animate-pulse" : undefined,
        animation === "shimmer"
          ? "skeleton-shimmer bg-[length:220%_100%] bg-no-repeat"
          : undefined,
        className,
      )}
      style={{
        ...animationStyle,
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
